module.exports = __webpack_public_path__ + "static/SG_MARK_SIX-0ebd5a6063ad5260a227a3cedd95eee0.png";